import { render, staticRenderFns } from "./OrderProfitChart.vue?vue&type=template&id=31c0effd&scoped=true&"
import script from "./OrderProfitChart.vue?vue&type=script&lang=js&"
export * from "./OrderProfitChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderProfitChart.vue?vue&type=style&index=0&id=31c0effd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c0effd",
  null
  
)

export default component.exports